import { SkeletonLoader } from '@usap/widgets'
import React from 'react'
import OverlaySkeletonLoader from '../OverlaySkeletonLoader/OverlaySkeletonLoader'
import { SkeletonWrapper } from './SkeletonLoaderInstallAtShopCart.css'

const SkeletonLoaderInstallAtShopPDP: React.FC = () => (
  <OverlaySkeletonLoader padding="0">
    <SkeletonWrapper>
      <SkeletonLoader height="22px" width="20%" marginBottom="12px" backgroundColor="#DBDBDB" />
      <SkeletonLoader height="22px" width="30%" marginBottom="12px" backgroundColor="#DBDBDB" />
      <SkeletonLoader height="22px" width="30%" marginBottom="12px" backgroundColor="#DBDBDB" />
      <SkeletonLoader height="22px" width="70%" marginBottom="12px" backgroundColor="#DBDBDB" />
      <SkeletonLoader height="22px" width="100%" marginBottom="12px" backgroundColor="#DBDBDB" />
      <SkeletonLoader height="22px" width="100%" marginBottom="2px" backgroundColor="#DBDBDB" />
    </SkeletonWrapper>
  </OverlaySkeletonLoader>
)

export default SkeletonLoaderInstallAtShopPDP
